import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import {
  BackButton,
  Box,
  ButtonStyled,
  LazyImage,
  SpanStyled,
  TextStyled,
  ThemeLoader,
} from "../../../components/styled/Elements";
import {
  GreenSuccessCheck,
  PlaceholderImg,
  RedCancelIcon,
} from "../../../components/styled/AllImages";
import { useTranslation } from "react-i18next";
import { ContentWrapper } from "../../../components/styled/styled";
import { userDtlPermissionColumns } from "../../../helpers/adminConstants/TableConstants";
import { userPermissionsRows } from "../../../helpers/dummyConstants";
import { UserDetailsWrapper } from "./styled";
import Breadcrumbs from "../../../components/admin/Breadcrumbs/Breadcrumbs";
import { useNavigate, useParams } from "react-router-dom";
import { StyledTable } from "./components/UserPermissions";
import UsersApi from "../../../services/api/usersApi";
import { useUser } from "../../../context/userContext";
import { getModuleOperations } from "../../../utils";

const assetURL = process.env.REACT_APP_ASSET_URL;

const UserDetails = () => {
  const userData = {
    name: "Wade Warren",
    status: 1,
    type: "admin",
    branch: "north_region_branch",
    department: "corporate_administration",
    email: "wadewarren@gmail.com",
    phone: "(255) 555-0118",
    location: "P.O. Box: 84281,Riyadh, Saudi Arabia",
    dob: "21/11/1979",
    allowedLogins: "204",
  };

  const permissionsObj = {
    1: [],
    2: [],
    3: [],
    4: [],
    5: [],
    6: [],
  };

  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useUser();

  const [userDetails, setUserDetails] = useState({});
  const [dataLoading, setDataLoading] = useState(false);
  const [permissions, setPermissions] = useState(permissionsObj);

  const getSingleUser = async () => {
    try {
      setDataLoading(true);
      const { data, code } = await UsersApi.getSingleUser(id);
      if (code === 200) {
        const profileImg = data?.profile
          ? `${assetURL}/${data?.profile}`
          : PlaceholderImg;
        const uploadId = data?.user_detail?.upload_id
          ? `${assetURL}/${data?.user_detail?.upload_id}`
          : "";
        const uploadJobId = data?.user_detail?.upload_job_id
          ? `${assetURL}/${data?.user_detail?.upload_job_id}`
          : "";
        setUserDetails({
          user_id: data?.id,
          profile: profileImg,
          status: parseInt(data?.status),
          name: data?.name || "",
          job_role: data?.position || "",
          id_number: data?.user_detail?.id_number || "",
          email: data?.email || "",
          phone: data?.phone || "",
          hqBranch: data?.user_detail?.office_location || "",
          department: data?.user_detail?.department || "",
          location: data?.user_detail?.location || "N/A",
          date_of_birth: data?.user_detail?.date_of_birth || "",
          licenses_allowed: data?.user_detail?.licenses_allowed || "",
          user_type_id: data?.user_type_id || "",
          // permissions: JSON.stringify(data.permissions || {}),
          upload_id: uploadId,
          upload_job_id: uploadJobId,
        });
        if (parseInt(data?.user_type_id) === 3) {
          for (let i = 1; i <= 6; i++) {
            permissions[i] = [1, 2, 3, 4, 5, 6];
          }
        } else {
          const mappedPermissions = data?.user_permissions.reduce(
            (acc, curr) => {
              const type = curr.permission_type_id;
              const operation = curr.permission_operation_id;

              if (!acc[type]) {
                acc[type] = [];
              }
              acc[type].push(operation);

              return acc;
            },
            {}
          );

          for (let i = 1; i <= 6; i++) {
            if (!mappedPermissions[i]) {
              mappedPermissions[i] = [];
            }
          }
          Object.keys(mappedPermissions).forEach((type) => {
            const uniqueOperations = [...new Set(mappedPermissions[type])];

            if (uniqueOperations.length === 5) {
              mappedPermissions[type] = [...uniqueOperations];
            } else {
              mappedPermissions[type] = uniqueOperations;
            }
          });
          setPermissions(mappedPermissions);
        }
      }
    } catch (error) {
    } finally {
      setDataLoading(false);
    }
  };

  useEffect(() => {
    getSingleUser();
  }, []);

  return (
    <UserDetailsWrapper>
      <Box className="content-head">
        <Box className="d-flex align-items-center flex-wrap flex-sm-nowrap gap-3 gap-md-5">
          <BackButton
            label={t("user_details")}
            onClick={() => navigate("/users")}
          />
          <Breadcrumbs />
        </Box>
      </Box>
      <ContentWrapper>
        {dataLoading ? (
          <ThemeLoader />
        ) : (
          <Box className="d-flex flex-wrap">
            <Col md={4} sm={12} className="user-info-box col-12">
              <Box className="d-flex align-items-center justify-content-between gap-1">
                <Box className="d-flex align-items-center gap-2">
                  <LazyImage
                    src={userDetails?.profile}
                    alt="User avatar"
                    className="rounded-circle"
                    style={{ width: "48px", height: "48px" }}
                  />
                  <Box>
                    <TextStyled size="20px" weight="900" className="mb-0">
                      {userDetails.name}
                    </TextStyled>
                    <SpanStyled
                      size="16px"
                      weight="400"
                      color="var(--text2)"
                      className="mb-0"
                    >
                      {userDetails.id_number}
                    </SpanStyled>
                  </Box>
                </Box>
                {user && Number(user?.user_type_id) !== 4 && (
                  <ButtonStyled
                    label={t("edit_user")}
                    onClick={() => navigate(`/users/edit-user/${id}`)}
                  />
                )}
              </Box>
              <Box className="d-flex align-items-center gap-2">
                <Col sm={4} className="col-4">
                  <SpanStyled color="var(--text2)">{t("status")}</SpanStyled>
                </Col>
                <Col>
                  <SpanStyled
                    color={
                      userDetails?.status === 1
                        ? "var(--themeColor2)"
                        : "var(--redColor)"
                    }
                  >
                    {t(userDetails.status === 1 ? "active" : "deactive")}
                  </SpanStyled>
                </Col>
              </Box>

              {[
                {
                  label: "type",
                  value:
                    parseInt(userDetails.user_type_id) === 3 ? "admin" : "user",
                },
                {
                  label: "JobRole",
                  value: userDetails.job_role,
                },
                {
                  label: "branch_hq",
                  value:
                    language === "en"
                      ? userDetails?.hqBranch?.name_en
                      : userDetails?.hqBranch?.name_ar,
                },
                {
                  label: "department",
                  value:
                    language === "en"
                      ? userDetails?.department?.name_en
                      : userDetails?.department?.name_ar,
                },
                { label: "email", value: userDetails.email },
                { label: "phone", value: userDetails.phone },
                { label: "location", value: userDetails.location },
                { label: "date_of_birth", value: userDetails.date_of_birth },
                {
                  label: "no_of_licenses_allowed",
                  value: userDetails.licenses_allowed,
                },
              ].map((field, index) => (
                <Box key={index} className="d-flex gap-2 align-items-center">
                  <Col sm={4} className="col-4">
                    <SpanStyled color="var(--text2)">
                      {t(field.label)}
                    </SpanStyled>
                  </Col>
                  <Col>
                    <Box style={{ direction: "ltr" }}>{t(field.value)}</Box>
                  </Col>
                </Box>
              ))}
              <Box className="d-flex gap-2">
                <Col sm={4} className="col-4">
                  <SpanStyled color="var(--text2)">{t("id")}</SpanStyled>
                </Col>
                <Col>
                  <LazyImage
                    src={userDetails?.upload_id}
                    alt="ID Card"
                    className="img-fluid"
                  />
                </Col>
              </Box>
              <Box className="d-flex gap-2">
                <Col sm={4} className="col-4">
                  <SpanStyled color="var(--text2)">{t("job_id")}</SpanStyled>
                </Col>
                <Col>
                  <LazyImage
                    src={userDetails?.upload_job_id}
                    alt="Job ID Card"
                    className="img-fluid"
                  />
                </Col>
              </Box>
            </Col>

            <Col md={8} sm={12} className="p-0 col-12 overflow-x-auto">
              <StyledTable className="border-0">
                <thead>
                  <tr>
                    {userDtlPermissionColumns.map((col, index) => (
                      <th
                        key={index}
                        className={`${col.title === "" && "title-column"}`}
                      >
                        <SpanStyled
                          size="16px"
                          color="var(--text)"
                          weight="bold"
                        >
                          {t(col.title)}
                        </SpanStyled>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {userPermissionsRows.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      {userDtlPermissionColumns.map((col, colIndex) => (
                        <td key={colIndex}>
                          <Box className="d-flex justify-content-center">
                            {col.name === "module_name" ? (
                              <SpanStyled size="16px" color="var(--text2)">
                                {t(row[col.name])}
                              </SpanStyled>
                            ) : col.name === "download" &&
                              Number(row.id) !== 3 ? (
                              <SpanStyled size="32px" color="var(--text2)">
                                -
                              </SpanStyled>
                            ) : permissions[row.id]?.includes(row[col.name]) ? (
                              <GreenSuccessCheck />
                            ) : (
                              <RedCancelIcon />
                            )}
                          </Box>
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </StyledTable>
            </Col>
          </Box>
        )}
      </ContentWrapper>
    </UserDetailsWrapper>
  );
};

export default UserDetails;
